// extracted by mini-css-extract-plugin
export default {"myAccountTabs":"bnUipv5","tablistOuter":"rCnABpg","gradientLeft":"dgI3_9j","tablist":"rjI0pXq","gradientRight":"r2CqIKF","button":"gCBFoSR","active":"IgP0iDU","panel":"kPGFNE2"};